import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';

/**
 * The root component of the Luminav Link application.
 *
 * @selector app-root
 * @standalone true
 * @imports RouterOutlet, MatSlideToggleModule, TranslateModule
 * @templateUrl ./app.component.html
 * @styleUrls ./app.component.scss
 *
 * @class AppComponent
 * @property {string} title - The title of the application.
 *
 * @constructor
 * @param {TranslateService} translate - The translation service used to manage language translations.
 *
 * The constructor initializes the translation service by adding supported languages
 * and setting the default language to English.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    TranslateModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    library: FaIconLibrary
  ) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');

    // Initialize FontAwesome icons
    library.addIconPacks(far, fas, fal);
  }
}
